// extracted by mini-css-extract-plugin
module.exports = {"footer":"Account_footer__X1f7G"};